import { useEffect, useState } from 'react';

import { Constant } from '../../../../../../../../Helpers/constant';

import { useDispatch } from 'react-redux';
import { GET_BOOKING_DETAILS_EMPTY } from '../../../../../../../../../store/actions';
import HotClock from './../../../../../../../../../assets/custom/hot-clock.png';
import SufficientClock from './../../../../../../../../../assets/custom/sufficient-clock.png';
import WarningClock from './../../../../../../../../../assets/custom/warning-clock.png';
import CustomizedTable from './CustomizedTable';

const TabularView = ({
  data,
  schema,
  totalCount,
  skip,
  limit,
  handleRowsPerPageChange,
  handlePageChange,
  setCurrentSelectedBooking,
  selectedBooking,
  isTableDisplay,
  bookingType,
  appliedName = '',
  isMultiSelectable,
  shouldHaveClearSelection,
}) => {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [bookingsData, setBookingsData] = useState([]);
  const [columns, setColumns] = useState([]);

  const handleRowSelected = state => {
    setCurrentSelectedBooking(state?.selectedRows);
  };

  const checkboxHandler = rowData => {
    if (!isMultiSelectable) {
      if (selectedBooking?.[0]?.id === rowData?.id) {
        dispatch({
          type: GET_BOOKING_DETAILS_EMPTY,
        });

        setCurrentSelectedBooking(null);
      } else {
        setCurrentSelectedBooking([{ ...rowData }]);
      }
    }
  };

  const configureColumn = (row, tSchema) => {
    const key = tSchema?.key;

    let content = '';
    if (key === 'tat') {
      content = (
        <div className="d-flex align-items-center gap-1">
          {row?.[key]?.color === '#FCE2E2' && <img src={HotClock} className="tabular-remaining-clock" />}
          {row?.[key]?.color === '#FFF5E7' && <img src={WarningClock} className="tabular-remaining-clock" />}
          {row?.[key]?.color === '#E5EBFF' && <img src={SufficientClock} className="tabular-remaining-clock" />}

          <span>{`${row?.[key]?.value} ${row?.[key]?.unit}`}</span>
        </div>
      );
    } else if (key === 'name' || key === 'firstName') {
      content = (
        <>
          {isMultiSelectable ? (
            <div className="d-flex align-items-center gap-1">
              <span>{row?.[key] ?? ''}</span>
            </div>
          ) : (
            <span
              className="cursor-pointer text-decoration-underline"
              style={{ color: row?.rowColorCode ? row?.rowColorCode : '#3577f1' }}
              onClick={() => setCurrentSelectedBooking([{ ...row?.originalData }])}
            >
              {row?.[key]}
            </span>
          )}
        </>
      );
    } else if (key === 'status') {
      const status = row?.[key]?.toLowerCase();
      let statusClass = 'custom-status-badge ';
      if (status === 'live' || status === 'active') statusClass += 'custom-status-live';
      else if (status === 'pending') statusClass += 'custom-status-pending';
      else if (status === 'rejected') statusClass += 'custom-status-rejected';
      else if (status === 'draft') statusClass += 'custom-status-draft';
      else if (status === 'approved') statusClass += 'custom-status-approved';
      else if (status === 'published') statusClass += 'custom-status-published';

      content = <span className={statusClass}>{row?.[key]}</span>;
    } else {
      content = row?.[key] ?? 'NA';
    }

    return <span>{content}</span>;
  };

  const makeColumns = () => {
    if (!schema) return [];
    return schema?.map(tSchema => ({
      name: tSchema?.label || '',
      width: `${tSchema?.metadata?.width || '100px'}`,
      wrap: true,
      cell: row => configureColumn(row, tSchema),
    }));
  };

  useEffect(() => {
    if (data?.length > 0) {
      const fetchColumns = [
        ...(!isMultiSelectable
          ? [
              {
                name: '',
                width: '50px',
                selector: row => row?.serial_number,
                cell: row => (
                  <input
                    className="form-check-input cursor-pointer"
                    type="checkbox"
                    // checked={row?.bookingId === selectedBooking?.bookingId}
                    checked={selectedBooking?.filter(booking => booking?.id === row?.id)?.length > 0}
                    onChange={() => checkboxHandler(row?.originalData)}
                  />
                ),
                omit: isMultiSelectable,
              },
            ]
          : []),
        ,
        {
          name: 'S.No',
          width: '70px',
          wrap: true,
          selector: row => row?.serial_number,
        },

        ...makeColumns(),
      ];
      setColumns(fetchColumns);

      setBookingsData(
        data?.map((bookingData, index) => {
          const serial_number = Number(limit || 0) * Number(skip || 0) + (index + 1);

          return {
            serial_number: serial_number,
            ...bookingData,
            serviceDateTime: bookingData?.serviceDateTime ? bookingData?.serviceDateTime : 'NA',
            status: bookingData?.status,
            assignedAgentName: bookingData?.assignedAgentName || 'NA',
            vendorName: bookingData?.vendorName || 'NA',
            originalData: bookingData,
          };
        }),
      );
    } else {
      setBookingsData([]);
      setColumns([]);
    }
  }, [data, selectedBooking, isMultiSelectable]);

  return (
    <CustomizedTable
      columns={columns ?? []}
      data={bookingsData ?? []}
      totalCount={totalCount}
      limit={limit}
      handleRowsPerPageChange={handleRowsPerPageChange}
      currentPage={skip}
      handlePageChange={handlePageChange}
      indexType={Constant.INDEX_TYPE.ZERO_BASED}
      isTableDisplay={isTableDisplay}
      selectableRows={isMultiSelectable ? true : false}
      clearSelectedRows={shouldHaveClearSelection}
      onSelectedRowsChange={handleRowSelected}
    />
  );
};

export default TabularView;
